import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["email", "companyId", "vid", "getAvatarsApi", "portalId"];
import { Avatar as AvatarComponent } from 'avatar-components/Avatar';
import { jsx as _jsx } from "react/jsx-runtime";
function Avatar(_ref) {
  var _Number;
  let {
      email,
      companyId,
      vid,
      getAvatarsApi,
      portalId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AvatarComponent, Object.assign({}, Object.assign({}, rest, email && {
    type: 'contact',
    email
  }, vid && {
    vid: (_Number = Number(vid)) !== null && _Number !== void 0 ? _Number : undefined
  }, companyId && {
    type: 'company',
    companyId
  }, {
    portalId,
    fetchAvatars: (_url, data) =>
    // TODO: using any here to fix the type error temporarily
    getAvatarsApi(data)
  })));
}
export default Avatar;